import { BudgetInterface } from "../dealer/budget-interface.model";

export interface ScheduleDetails {
    advisor?: string;
    advisorImg?: string;
    breakdownDate?: string;
    checklistDate?: string;
    requestedItems: BudgetInterface;
    recommendedItems: BudgetInterface;
    complementaryBudget: BudgetInterface;
    totalPrice?: number;
}
